/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterClaimPaymentsQueryDto
 */
export interface FilterClaimPaymentsQueryDto {
    /**
     * Filter by transaction date from
     * @type {Date}
     * @memberof FilterClaimPaymentsQueryDto
     */
    transactionDateFrom?: Date;
    /**
     * Filter by transaction date to
     * @type {Date}
     * @memberof FilterClaimPaymentsQueryDto
     */
    transactionDateTo?: Date;
    /**
     * Filter by insured IDs
     * @type {Array<string>}
     * @memberof FilterClaimPaymentsQueryDto
     */
    insureds?: Array<string>;
    /**
     * Filter by binder IDs
     * @type {Array<string>}
     * @memberof FilterClaimPaymentsQueryDto
     */
    binders?: Array<string>;
    /**
     * Filter by reinsured IDs
     * @type {Array<string>}
     * @memberof FilterClaimPaymentsQueryDto
     */
    reinsureds?: Array<string>;
    /**
     * Filter by broker IDs
     * @type {Array<string>}
     * @memberof FilterClaimPaymentsQueryDto
     */
    brokers?: Array<string>;
    /**
     * Filter by payment status
     * @type {Array<string>}
     * @memberof FilterClaimPaymentsQueryDto
     */
    paymentStatuses?: Array<FilterClaimPaymentsQueryDtoPaymentStatusesEnum>;
    /**
     * Filter by bank account numbers
     * @type {Array<string>}
     * @memberof FilterClaimPaymentsQueryDto
     */
    bankAccountNumbers?: Array<string>;
    /**
     * Search query for transaction ID, insured, binder, reinsured, or broker
     * @type {string}
     * @memberof FilterClaimPaymentsQueryDto
     */
    search?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FilterClaimPaymentsQueryDto
     */
    includeInsured?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterClaimPaymentsQueryDto
     */
    includeBinder?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterClaimPaymentsQueryDto
     */
    includeReinsured?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterClaimPaymentsQueryDto
     */
    includeBroker?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterClaimPaymentsQueryDto
     */
    includeBankAccount?: boolean;
}


/**
 * @export
 */
export const FilterClaimPaymentsQueryDtoPaymentStatusesEnum = {
    AwaitingApproval: 'Awaiting Approval',
    Approved: 'Approved',
    NotApproved: 'Not Approved',
    Paid: 'Paid'
} as const;
export type FilterClaimPaymentsQueryDtoPaymentStatusesEnum = typeof FilterClaimPaymentsQueryDtoPaymentStatusesEnum[keyof typeof FilterClaimPaymentsQueryDtoPaymentStatusesEnum];


/**
 * Check if a given object implements the FilterClaimPaymentsQueryDto interface.
 */
export function instanceOfFilterClaimPaymentsQueryDto(value: object): value is FilterClaimPaymentsQueryDto {
    return true;
}

export function FilterClaimPaymentsQueryDtoFromJSON(json: any): FilterClaimPaymentsQueryDto {
    return FilterClaimPaymentsQueryDtoFromJSONTyped(json, false);
}

export function FilterClaimPaymentsQueryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterClaimPaymentsQueryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'transactionDateFrom': json['transactionDateFrom'] == null ? undefined : (new Date(json['transactionDateFrom'])),
        'transactionDateTo': json['transactionDateTo'] == null ? undefined : (new Date(json['transactionDateTo'])),
        'insureds': json['insureds'] == null ? undefined : json['insureds'],
        'binders': json['binders'] == null ? undefined : json['binders'],
        'reinsureds': json['reinsureds'] == null ? undefined : json['reinsureds'],
        'brokers': json['brokers'] == null ? undefined : json['brokers'],
        'paymentStatuses': json['paymentStatuses'] == null ? undefined : json['paymentStatuses'],
        'bankAccountNumbers': json['bankAccountNumbers'] == null ? undefined : json['bankAccountNumbers'],
        'search': json['search'] == null ? undefined : json['search'],
        'includeInsured': json['includeInsured'] == null ? undefined : json['includeInsured'],
        'includeBinder': json['includeBinder'] == null ? undefined : json['includeBinder'],
        'includeReinsured': json['includeReinsured'] == null ? undefined : json['includeReinsured'],
        'includeBroker': json['includeBroker'] == null ? undefined : json['includeBroker'],
        'includeBankAccount': json['includeBankAccount'] == null ? undefined : json['includeBankAccount'],
    };
}

export function FilterClaimPaymentsQueryDtoToJSON(json: any): FilterClaimPaymentsQueryDto {
    return FilterClaimPaymentsQueryDtoToJSONTyped(json, false);
}

export function FilterClaimPaymentsQueryDtoToJSONTyped(value?: FilterClaimPaymentsQueryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactionDateFrom': value['transactionDateFrom'] == null ? undefined : ((value['transactionDateFrom']).toISOString()),
        'transactionDateTo': value['transactionDateTo'] == null ? undefined : ((value['transactionDateTo']).toISOString()),
        'insureds': value['insureds'],
        'binders': value['binders'],
        'reinsureds': value['reinsureds'],
        'brokers': value['brokers'],
        'paymentStatuses': value['paymentStatuses'],
        'bankAccountNumbers': value['bankAccountNumbers'],
        'search': value['search'],
        'includeInsured': value['includeInsured'],
        'includeBinder': value['includeBinder'],
        'includeReinsured': value['includeReinsured'],
        'includeBroker': value['includeBroker'],
        'includeBankAccount': value['includeBankAccount'],
    };
}

